<script setup>
import { Head, Link } from "@inertiajs/vue3";

import VAlert from "@/Shared/VAlert.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import VInputReadonlyWithLabel from "../../Shared/Form/VInputReadonlyWithLabel.vue";
import VDevider from "../../Shared/VDevider.vue";
import { computed, ref } from "vue";
import VButton from "../../Shared/Buttons/VButton.vue";

const props = defineProps({
    title: String,
    additional: Object,
});

const {
    urlBack,
    urlDownload,
    urlVerify,
    attachment,
    document,
    logo,
    logoEmet,
    email,
    name,
} = props.additional;

const breadcrumbs = [
    {
        url: "#",
        label: "Documents Scanner",
    },
];

const iframeEl = ref(null);

const isVerified = computed(() => {
    return props.additional.document.is_verified == 1;
});

const content = computed(() => {
    const verifiedText = isVerified.value ? "Verified" : "Not Verified";

    return `
        <html>
        <head>
            <title>Print Layout</title>
            <style>
                body {
                    width: 50mm;
                    height: 30mm;
                    font-family: Arial; font-size: 7pt;
                    margin: 0mm;
                    padding:0mm;
                }

                @page {
                    size: 50mm 30mm;
                    margin: 0px;
                    padding: 0px;
                }
            </style>
        </head>
        <body>
            <div style="text-align:center;padding-top:3mm">
                <img src="${logo}""
                    style="width:60pt;height:30pt" />
                <img src="${logoEmet}"
                    style="width:60pt;height:30pt" />
                <div>${verifiedText}</div>
                <div>Name: ${name}</div>
                <div>Email: ${email}</div>
            </div>
        </body>
        </html>
    `;
});

const print2 = () => {
    const printWindow = window.open("", "", "width=600,height=400");

    printWindow.document.write(content);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
};

const print = function () {
    const doc = iframeEl.value.contentWindow.document;

    // Write your content into the iframe
    doc.open();
    doc.write(content.value);
    doc.close();

    // Wait for iframe to load + images
    iframeEl.value.onload = () => {
        iframeEl.value.contentWindow.focus();
        iframeEl.value.contentWindow.print();
    };
};
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <VAlert v-if="!isShowForm && isShowAlert" />

        <div class="card">
            <div class="card-body">
                <div class="text-end">
                    <Link class="btn btn-light" :href="urlBack">
                        <span class="material-icons"> qr_code </span>
                        Scan Document
                    </Link>
                    <a
                        class="btn btn-primary"
                        :href="urlDownload"
                        target="_blank"
                    >
                        <span class="material-icons"> picture_as_pdf </span>
                        Download
                    </a>
                </div>
                <VDevider />
                <div class="row">
                    <div class="col-lg-6">
                        <div class="mb-3">
                            <VInputReadonlyWithLabel
                                label="Email"
                                :value="document.email"
                                :isPlainText="false"
                            />
                        </div>
                        <div class="mb-3">
                            <VInputReadonlyWithLabel
                                label="No Registrasi / No. Ticket"
                                :value="document.registration_id"
                                :isPlainText="false"
                            />
                        </div>
                        <div class="row">
                            <div class="col-lg-9 offset-lg-3 offset-0">
                                <Link
                                    class="btn"
                                    :class="{
                                        'btn-light': !isVerified,
                                        'btn-success': isVerified,
                                    }"
                                    :href="urlVerify"
                                    method="post"
                                >
                                    {{ isVerified ? "Verified" : "Verify" }}
                                </Link>
                                <VButton @onClick="print" btnStyle="btn-warning"
                                    >Print</VButton
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="m-3">
                            <div v-for="image in attachment" class="">
                                <img :src="image" alt="ktp" class="w-100" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <iframe ref="iframeEl" id="printFrame" style="display: none"></iframe>
    </div>
</template>
